import { render } from "./GhostDraftSimple.vue?vue&type=template&id=4af15244&ts=true"
import script from "./GhostDraftSimple.vue?vue&type=script&lang=ts"
export * from "./GhostDraftSimple.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/GhostDraftSimple.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4af15244"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4af15244', __exports__)) {
    api.reload('4af15244', __exports__)
  }
  
  module.hot.accept("./GhostDraftSimple.vue?vue&type=template&id=4af15244&ts=true", () => {
    api.rerender('4af15244', render)
  })

}


export default __exports__